<template>
	<div class="step2">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="top_tit"><span>|</span> 会员管理系统</h5>
			<p class="welcom">欢迎您
				<span class="name">{{name}}</span><span>|</span></p>
			<a class="out" @click="out">退出</a>
		</div>
		<div class="middle">
			<p class="introducer">入会流程</p>
			<div class="con">
				<div class="con_top">
					<p class="flow_pic">
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">注册账号</span> <span class="lines line1"></span>
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">填写入会申请表</span> <span class="lines line1"></span>
						<span class="cirl">3</span> <span class="flow flow2">打印盖章并上传</span> <span class="lines "></span>
						<span class="cirl">4</span> <span class="flow">缴费并等待审核</span>
					</p>
				</div>
				<div class="con_con">

					<div class="con_con_left" id="home">
						<div id="pdfDom" class="form" ref="pdf">
							<p class="title">中国质量协会单位会员入会申请表</p>
							<div class="form-wrapper">
								<div class="first-line line" style="height:auto;">
									<span class="first-line-title">单位名称</span>
									<p class="border-l-r border" style="word-wrap: break-word;">{{ruleForm.name}}</p>
									<span>行业类别</span>
									<p class="border border-left">{{ruleForm.sort}}</p>
								</div>

								<div class="second-line line" style="height:auto;">
									<span>通讯地址</span>
									<p class="border border-l-r" style="word-break: break-word;">{{ruleForm.addres1}}</p>
									<span>职工人数</span>
									<p class="border border-left">{{ruleForm.people_num}}</p>
								</div>

								<div class="third-line line">
									<span style>单位网址</span>
									<p class="border border-l-r">{{ruleForm.addres2}}</p>
									<span class="border border-right">企业性质</span>
									<p>{{ruleForm.kind}}</p>
								</div>

								<div class="fourth-line line">
									<span>邮政编码</span>
									<p class="border border-left">{{ruleForm.youbian}}</p>
									<span class="border border-left">传真</span>
									<p class="border-left border" style="word-break:break-all;">{{ruleForm.chuanzhen}}</p>
									<span class="border-left border">电话</span>
									<p class="border-left border">{{ruleForm.dianhua}}</p>
								</div>

								<div class="five-line line">
									<span>是否有母公司</span>
									<p class="border border-left">{{ruleForm.whether}}</p>
									<span class="border border-left">母公司名称</span>
									<p class="border border-left">{{ruleForm.name1}}</p>
								</div>

								<div class="six-line line">
									<span>法人代表</span>
									<p class="border border-left">{{ruleForm.faren}}</p>
									<span class="border border-left">职务</span>
									<p class="border border-left">{{ruleForm.zhiwu1}}</p>
									<span class="border border-left">电话</span>
									<p class="border border-left">{{ruleForm.dianhua1}}</p>
								</div>

								<div class="seven-line line">
									<span>最高管理者</span>
									<p class="border border-left">{{ruleForm.leader}}</p>
									<span class="border border-left">职务</span>
									<p class="border border-left">{{ruleForm.zhiwu2}}</p>
									<span class="border border-left">电话</span>
									<p class="border border-left">{{ruleForm.dianhua2}}</p>
								</div>

								<div class="eight-line line">
									<span>联系部门</span>
									<p class="p border border-left">{{ruleForm.bumen}}</p>
									<div class="border border-left">
										<p class="border border-bottom">负责人</p>
										<p>联系人</p>
									</div>

									<div class="border border-left ">
										<p class="border border-bottom ">{{ruleForm.name2}}</p>
										<!--联系人-->
										<p class="border">{{ruleForm.name3}}</p>
									</div>

									<div class="clearfix border border-left">
										<p class="border border-bottom">电话</p>
										<p class="border border-bottom">email</p>
										<p class="border border-bottom">手机</p>
										<p class="border border-bottom">电话</p>
										<p class="border border-bottom">email</p>
										<p>手机</p>
									</div>

									<div class="clearfix border border-left">
										<!--负责人电话-->
										<p class="border border-bottom">{{ruleForm.dianhua3}}</p>
										<!--负责人email-->
										<p class="border border-bottom">{{ruleForm.email}}</p>
										<!--负责人手机-->
										<p class="border border-bottom">{{ruleForm.dianhua4}}</p>
										<!--联系人电话-->
										<p class="border border-bottom">{{ruleForm.dianhua5}}</p>
										<!--联系人email-->
										<p class="border border-bottom">{{ruleForm.email1}}</p>
										<!--联系人手机-->
										<p>{{ruleForm.dianhua6}}</p>
									</div>
								</div>

								<!--第九行-->
								<div class="border border-bottom" style="display: flex;">
									<p style="width:20px;text-align: right;" class="float_l clearfix border border-right flex">经营概况</p>
									<div class="float_l clearfix" style="width: 400px;">

										<div class="line border-bottom" style="display: flex;">
											<span class="float_l clearfix border border-right flex" style="width: 130px;padding: 5px 0;">主要产品和服务</span>
											<p class="float_l clearfix flex" style="width:270px;padding: 5px 0;">{{ruleForm.product}}</p>
										</div>

										<div class="line border-bottom" style="height: 20px;line-height: 20px;">
											<span class="float_l clearfix border border-right" style="width: 55px;height: 20px;">总资产</span>
											<p class="float_l clearfix border border-right rap" style="width:145px;height: 20px;">{{ruleForm.zichan}}（万元）</p>
											<span class="float_l clearfix border border-right" style="width: 60px;">销售收入</span>
											<p class="float_l clearfix rap" style="width: 140px;">{{ruleForm.shouru}}（万元）</p>
										</div>

										<div style="height: 21px;line-height: 21px;">
											<span class="float_l clearfix border border-right" style="width: 55px;height: 20px;">总负债</span>
											<p class="float_l clearfix border border-right rap" style="width:145px;height: 20px;">{{ruleForm.fuzhai}}（万元）</p>
											<span class="float_l clearfix border border-right" style="width: 60px;">实现利税</span>
											<p class="float_l clearfix rap" style="width: 140px;">{{ruleForm.lishui}}（万元）</p>
										</div>
									</div>
								</div>
								<!--第十行-->
								<div class="line border-bottom" style=" display: flex;">
									<span class="float_l clearfix border border-right flex" style="width: 75px;">企业质量<br>管理情况</span>
									<p class="float_l clearfix" style="width: 345px;word-wrap: break-word;white-space:pre-wrap;text-indent: 20px;text-align: left;">{{ruleForm.status}}</p>
								</div>
								<!--第十一行-->
								<div style="display: flex;">
									<span class="float_l clearfix border border-right flex" style="width: 75px;">对协会工作的需求及建议</span>
									<p class="float_l clearfix border border-right" style="width: 145px;text-indent: 20px;white-space:pre-wrap;text-align: left;">{{ruleForm.need}}</p>
									<span class="float_l clearfix border border-right flex" style="width:60px;word-wrap: break-word;">单位意见</span>
									<p class="flex float_l clearfix rap" style="width: 140px;"><br><br>年 月 日<br>公章<br><br></p>
								</div>
							</div>
							<div style="width: 420px;height: 20px;margin: 0 auto;line-height: 20px;">
								<span class="float_l clearfix">填表人:</span>
								<p class="float_l clearfix" style="height: 20px;margin-right: 15px;">{{ruleForm.tbr}}</p>
								<span class=" float_l clearfix">填表日期:</span>
								<p class="float_l clearfix" style="margin-right: 15px;"> {{ruleForm.year}}年 {{ruleForm.month}}月 {{ruleForm.ri}}日</p>
								<span class=" float_l clearfix">推荐人:</span>
								<p class="float_l clearfix" style="height: 20px;">{{ruleForm.tj}}</p>
							</div>
						</div>
						<div class="con_bot">
							<router-link class="back" to="/step1">返回修改</router-link>
							<a class="down_load" @click="toStep22">生成并打印</a>
							<!--<router-link class="down_load" target="_blank" to="/step22">生成并打印</router-link>-->
						</div>
						<p class="note">支持png/jpg，若上传文件较多可上传压缩包（zip、rar），单个文件可直接上传，文件小于10M（注：上传文件只需一次，多次将会覆盖）。</p>
						<div class="upImg">
							<span class="upImg_tit">上传盖章扫描件</span>
							<div class="add">
								<label for="file" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 10; ">添加上传扫描件</label>
								<input type="file" id="file" class="file" @change="uploadFile($event)" multiple="multiple" accept='.jpg,.png,.zip,.rar'>
							</div>
							<span class="handlerImg" @click="handlerImg">上传</span>
						</div>
						<p class="fileName">{{filename}}</p>						
					</div>

					<div class="con_con_right">
						<p class="con_con_right_tit">
							<img class="notice_img" src="../../static/img/notice.png" /> 重要
							<span>提示</span>
						</p>
						<p class="pro">
							请下载打印《入会申请表》，加盖公章后扫描上传。<br><br> 通过审核（7个工作日内）的企业在完成缴纳会费后方可成功入会。 <br><br>
						</p>						
					</div>
				</div>
				<div style="text-align: center;margin-bottom: 18px;">					
					<input class="checkbox" id="checkbox" v-model="checked"  type="checkbox" /> <label for="checkbox">我已打印盖章并上传《入会申请表》</label>
				</div>
				<button :class="checked==true ?'btn1':'btn'" @click="submit">下一步</button>

			</div>
		</div>
		<bottom></bottom>
	</div>
</template>
<script>
	import { Message, MessageBox, Loading } from 'element-ui'
	import bottom from './Bottom'
	import Qs from 'qs'
	export default {
		components: {
			bottom
		},
		data() {
			return {
				checked: false,
				name: '',
				file:'',
				filename:'',
				ruleForm: {
					name: '',
					sort: '',
					addres1: '',
					people_num: '',
					addres2: '',
					kind: '',
					youbian: '',
					chuanzhen: '',
					dianhua: '',
					whether: '',
					name1: '',
					faren: '',
					zhiwu1: '',
					dianhua1: '',
					leader: '',
					zhiwu2: '',
					dianhua2: '',
					bumen: '',
					name2: '',
					dianhua3: '',
					email: '',
					dianhua4: '',
					name3: '',
					dianhua5: '',
					email1: '',
					dianhua6: '',
					product: '',
					zichan: '',
					shouru: '',
					fuzhai: '',
					lishui: '',
					tbr: '',
					tj:'',
					status: '',
					need: '',
					date1: '',
					year: '',
					month: '',
					ri: '',
				},
			};
		},

		created() {},
		mounted() {
			if(sessionStorage.getItem('name')) {
				this.name = sessionStorage.getItem('name');
			};
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			var data1 = {
				'access-token': token
			};
			this.$axios({
				method: 'post',
				url: 'society/applicationform',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state == 2) {
					if(response.data.data.length != 0) {

						var data = response.data.data;
						this.ruleForm.name = data.name;
						this.ruleForm.sort = data.professions;
						this.ruleForm.addres1 = data.address;
						this.ruleForm.people_num = data.number;
						this.ruleForm.addres2 = data.website;
						this.ruleForm.kind = data.company_type;
						this.ruleForm.youbian = data.postcode;
						this.ruleForm.chuanzhen = data.fax;
						this.ruleForm.dianhua = data.fax_tel;
						if(data.has_parent == '1') {
							this.ruleForm.whether = "是";
						} else {
							this.ruleForm.whether = "否";
						};
						if(data.central_enterprise == '1') {
							this.ruleForm.whether1 = "是";
						} else {
							this.ruleForm.whether1 = "否";
						};
						this.ruleForm.name1 = data.parent_name;
						this.ruleForm.faren = data.corporate;
						this.ruleForm.zhiwu1 = data.corporate_title;
						this.ruleForm.dianhua1 = data.corporate_tel;
						this.ruleForm.leader = data.ceo;
						this.ruleForm.zhiwu2 = data.ceo_title;
						this.ruleForm.dianhua2 = data.ceo_tel;
						this.ruleForm.bumen = data.department;
						this.ruleForm.name2 = data.department_manager;
						this.ruleForm.fu_zhiwu = data.department_title;
						this.ruleForm.dianhua3 = data.manager_tel;
						this.ruleForm.email = data.manager_email;
						this.ruleForm.dianhua4 = data.manager_phone;
						this.ruleForm.name3 = data.user_name;
						this.ruleForm.lian_zhiwu = data.user_title;
						this.ruleForm.dianhua5 = data.user_tel;
						this.ruleForm.email1 = data.user_email;
						this.ruleForm.dianhua6 = data.user_phone;
						this.ruleForm.product = data.service;
						this.ruleForm.zichan = data.total_assets;
						this.ruleForm.shouru = data.revenue;
						this.ruleForm.fuzhai = data.total_debt;
						this.ruleForm.lishui = data.profit;
						this.ruleForm.status = data.condition;
						this.ruleForm.need = data.suggestion;
						this.ruleForm.tbr = data.username;
						this.ruleForm.tj = data.referrer;
						this.ruleForm.year = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[0];
						this.ruleForm.month = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[1];
						this.ruleForm.ri = data.updated_at.split(' ')[0].replace(/-/g, "/").split('/')[2];
						this.ruleForm.s_name = data.addressee_name;
						this.ruleForm.s_dianhua = data.addressee_phone;
						this.ruleForm.s_youbian = data.addressee_zipcode;
						this.prov = data.province;
						this.city = data.city;
						this.district = data.district;
						this.ruleForm.xaddress = data.detailed_address;
					}
				}

			});
		},
		methods: {
			out() {
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1 = {
					'access-token': token
				};
				this.$axios({
					method: 'post',
					url: 'user/logout',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state == 1) {
//						sessionStorage.removeItem('Token');
//						localStorage.removeItem('sessionid');
						localStorage.clear();
						sessionStorage.clear();
						this.$router.push('/login');
					} else {
						this.$toast(response.data.msg);
					}
				})
			},
			toStep22(){
				let {href} = this.$router.resolve({path:'/step22'});
				window.open(href, '_blank');
			},
			uploadFile(event) {
				const isLt2M = event.target.files[0].size / 1024 / 1024 < 10 // 上传头像图片大小不能超过 2MB
				if(!isLt2M) {
					this.$toast('文件大小不能超过 10MB,请重新选择!');
				} else {
					this.file = event.target.files[0]; //获取input的图片file值
					this.filename = event.target.files[0].name;
					this.$toast('文件选择成功！');
				}
			},
			handlerImg() {
				if(this.filename == "") {
					this.$toast('请选择要上传的文件！')
					return false
				};
				Loading.service();
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
				let fileFormData = new FormData();
				fileFormData.append('file', this.file, this.filename); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
				fileFormData.append('access-token',token);
				let requestConfig = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				};
				this.$axios.post('society/uploadfileapi', fileFormData, requestConfig).then(response => {
					let loadingInstance = Loading.service();
					loadingInstance.close();
					this.$toast(response.data.msg);
				});
			},
			submit() {
				if(!this.checked) {
					this.$toast('是否已打印盖章并上传《入会申请表》');
					return false;
				}
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1 = {
					'access-token': token
				};
				this.$axios({
					method: 'post',
					url: 'society/next',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state == 2) {
						this.$router.push('/step3');
					} else {
						this.$toast(response.data.msg);
					}
				});

			},
		}
	}
</script>
<style scoped>
	.step2 {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		-webkit-text-size-adjust: none;
	}
	
	.top {
		height: 80px;
		position: relative;
	}
	
	.logo {
		width: 211px;
		height: 43px;
		position: absolute;
		top: 16px;
		left: 254px;
	}
	
	.top_tit {
		position: absolute;
		top: 26px;
		left: 480px;
		height: 28px;
		font-size: 20px;
		font-weight: bold;
		color: rgba(0, 94, 179, 1);
		line-height: 28px;
	}
	
	.top_tit span {
		height: 17px;
		color: #E8E8E8;
	}
	
	.welcom {
		position: absolute;
		top: 30px;
		right: 271px;
		width: 340px;
		text-align: right;
		color: #808080;
	}
	
	.name {
		color: #4A90E2;
		margin-right: 14px;
	}
	
	.out {
		cursor: pointer;
		position: absolute;
		top: 30px;
		right: 226px;
		font-size: 14px;
		font-weight: bold;
		color: #808080;
		line-height: 20px;
	}
	
	.middle {
		border-top: 1px solid rgba(0, 0, 0, 0);
		box-sizing: border-box;
		width: 100%;
		height: auto;
		background: rgba(246, 248, 249, 1);
		padding-bottom: 35px;
	}
	
	.introducer {
		font-size: 24px;
		color: #404040;
		text-align: left;
		text-indent: 254px;
		line-height: 75px;
	}
	
	.con {
		text-align: left;
		margin: 0 auto;
		width: 1160px;
		height: auto;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
		padding-bottom: 40px;
	}
	
	.con_top {
		padding-top: 25px;
		height: 45px;
		border-bottom: 1px solid #E0E0E0;
	}
	
	.flow_pic {
		height: 20px;
		text-align: center;
		vertical-align: middle;
		color: #595959;
	}
	
	.yet {
		margin-right: 14px;
		width: 20px;
		height: 20px;
		display: inline-block;
		vertical-align: middle;
	}
	
	.flow1 {
		color: #0076FF;
	}
	
	.flow2 {
		color: #FF9600;
	}
	
	.lines {
		margin: 0 19px;
		width: 47px;
		height: 2px;
		display: inline-block;
		background: #BFBFBF;
		vertical-align: middle;
	}
	
	.line1 {
		background: #0076FF;
	}
	
	.cirl {
		display: inline-block;
		width: 20px;
		height: 20px;
		border: 1px solid #BFBFBF;
		border-radius: 100%;
		line-height: 20px;
		text-align: center;
		color: #BFBFBF;
		margin-right: 14px;
	}
	
	.con_con {
		width: 100%;
		height: auto;
		padding: 40px 0 0 0;
		box-sizing: border-box;
		overflow: hidden;
		margin-bottom: 20px;
	}
	
	.con_con_left {
		float: left;
		width: 495.42px;
		height: auto;
		color: #545454;
		text-align: center;
		margin-left: 113px;
	}
	/*表格*/
	
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.float_l {
		float: left;
	}
	
	.rap {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.form {
		margin: 0 auto;
		background: #fff;
		width: 510px;
		color: #333;
		text-align: center;
		font-family: '宋体';
	}
	
	.form .title {
		margin-bottom: 15px;
		font-size: 16px;
		color: #000;
	}
	
	.form-wrapper {
		width: 420px;
		height: auto;
		margin: 0 auto;
		font-size: 8px;
		border-style: solid;
		border-width: 1px;
		border-color: #333;
	}
	
	.line {
		align-items: stretch;
		box-sizing: border-box;
		border-width: 1px;
		border-color: #333;
		border-style: hidden hidden solid hidden;
	}
	
	.line p {
		/*white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;*/
	}
	
	.border-left {
		border-style: hidden hidden hidden solid;
	}
	
	.border-top {
		border-style: solid hidden hidden hidden;
	}
	
	.border-right {
		border-style: hidden solid hidden hidden;
	}
	
	.border-bottom {
		border-style: hidden hidden solid hidden;
	}
	
	.border-l-r {
		border-style: hidden solid hidden solid;
	}
	
	.border {
		border-width: 1px;
		border-color: #333;
		box-sizing: border-box;
	}
	
	.first-line,
	.second-line,
	.fourth-line,
	.six-line {
		width: 100%;
		display: flex;
		align-items: stretch;
	}
	
	.first-line span:nth-child(1),
	.second-line span:nth-child(1),
	.third-line span:nth-child(1),
	.fourth-line span:nth-child(1),
	.six-line span:nth-child(1),
	.seven-line span:nth-child(1) {
		padding: 5px 0;
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.first-line p:nth-child(2),
	.second-line p:nth-child(2) {
		width: 220px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.first-line span:nth-child(3),
	.second-line span:nth-child(3),
	.third-line span:nth-child(3) {
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.first-line p:nth-child(4),
	.second-line p:nth-child(4) {
		width: 78px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.third-line,
	.five-line,
	.seven-line {
		width: 100%;
		/*height: 30px;*/
		height: auto;
		display: flex;
		/*line-height: 30px;*/
		align-items: stretch;
	}
	
	.third-line p:nth-child(2) {
		word-break: break-word;
		width: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.third-line p:nth-child(4) {
		width: 138px;
		/*	height: 100%;*/
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.fourth-line p:nth-child(2) {
		width: 49px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.fourth-line span:nth-child(3) {
		width: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.fourth-line p:nth-child(4) {
		width: 70px;
		/*height: 100%;*/
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.fourth-line span:nth-child(5) {
		width: 60px;
		/*height: 100%;*/
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.fourth-line p:nth-child(6) {
		width: 138px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.five-line {
		width: 100%;
		/*height: 30px;*/
		display: flex;
		align-items: stretch;
	}
	
	.five-line span:nth-child(1) {
		width: 109px;
		/*height: 100%;*/
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.five-line p:nth-child(2) {
		width: 40px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.five-line span:nth-child(3) {
		width: 70px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.five-line p:nth-child(4) {
		width: 198px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.six-line p:nth-child(2) {
		width: 49px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.six-line span:nth-child(3) {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
	}
	
	.six-line p:nth-child(4) {
		width: 70px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.six-line span:nth-child(5) {
		width: 60px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.six-line p:nth-child(6) {
		width: 138px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.seven-line p:nth-child(2) {
		width: 49px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.seven-line span:nth-child(3) {
		width: 40px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.seven-line p:nth-child(4) {
		width: 70px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.seven-line span:nth-child(5) {
		width: 60px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.seven-line p:nth-child(6) {
		width: 138px;
		padding: 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.eight-line {
		width: 100%;
		height: 125px;
		display: flex;
		/*align-items: stretch;*/
	}
	
	.eight-line span:nth-child(1) {
		float: left;
		width: 60px;
		height: 100%;
		line-height: 120px;
	}
	
	.eight-line p.p {
		display: flex;
		align-items: center;
		justify-content: center;
		/*float: left;*/
		width: 49px;
		/*height: 100%;*/
	}
	
	.eight-line div:nth-child(3) {
		float: left;
		width: 40px;
		height: 100%;
	}
	
	.eight-line div:nth-child(3) p {
		width: 100%;
		height: 62px;
		line-height: 62px;
	}
	
	.eight-line div:nth-child(4) {
		float: left;
		width: 70px;
		height: 100%;
	}
	
	.eight-line div:nth-child(4) p {
		width: 100%;
		height: 62px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.eight-line div:nth-child(5) {
		float: left;
		width: 60px;
		height: 100%;
	}
	
	.eight-line div:nth-child(5) p,
	.eight-line div:nth-child(6) p {
		height: 20.5px;
		line-height: 20.5px;
	}
	
	.eight-line div:nth-child(6) {
		float: left;
		width: 141px;
		height: 100%;
	}
	
	.eight-line div:nth-child(6) p {
		height: 20.5px;
	}
	
	.con_bot {
		padding-top: 45px;
		width: 60%;
		height: 40px;
		margin:0 auto 85px;
	}
	
	.back {
		height: 40px;
		line-height: 40px;
		float: right;
		color: rgba(64, 64, 64, 1);
	}
	
	
	.down_load {
		cursor: pointer;
		float: left;
		cursor: pointer;
		text-align: center;
		color: #fff;
		font-size: 16px;
		line-height: 40px;
		width: 145px;
		height: 40px;
		border-radius: 4px;
		background: rgba(24, 144, 255, 1);
	}
	
	.upImg{
		padding-left: 40px;
		box-sizing: border-box;
		text-align: left;
		width: 100%;
		line-height: 38px;
	}
	.upImg_tit{
		display: inline-block;
		height: 38px;
		color: #000;
		font-size: 16px;
		vertical-align: middle;
	}
	.add {
		text-align: center;
		line-height: 36px;
		vertical-align: middle;
		display: inline-block;
		position: relative;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		width: 145px;
		height: 36px;
		border: 1px solid #333;
		border-radius: 5px;
		margin: 0 20px;
	}
	.add:active{
		background: rgba(24, 144, 255, 1);
		color: #fff;
		border:none;
	}
	.file {
		position: absolute;
		left: -9999px;
	}
	.handlerImg{
		cursor: pointer;
		text-align: center;
		line-height: 38px;
		color: #fff;
		width: 65px;
		border-radius: 5px;
		background: rgba(24, 144, 255, 1);
		display: inline-block;
	}
	.handlerImg:active{
		background: blue;
	}
	.note,.fileName {
		text-align: left;
		padding-left: 175px;
		margin-bottom: 10px;
		color: #CFD4D6;
	}
	.note{
		color: red;
	}
	.fileName {
		padding-top: 5px;
		margin-bottom: 45px;
	}
	
	.con_con_right {
		float: right;
		height: 405px;
		width: 402px;
		padding: 0 65px 0 33px;
		margin-top: 76px;
		box-sizing: border-box;
		border-left: 2px solid #979797;
	}
	
	.con_con_right_tit {
		height: 24px;
		line-height: 24px;
		padding-top: 10px;
		font-size: 20px;
		color: #434343;
		font-weight: bold;
		margin-bottom: 27px;
	}
	
	.notice_img {
		width: 24px;
		height: 24px;
		display: inline-block;
		vertical-align: top;
	}
	
	.con_con_right_tit span {
		color: #FFBC31;
	}
	
	.pro {
		color: #434343;
		font-size: 15px;
		font-weight: bold;
		margin-bottom: 13px;
	}
	
	.addres {
		line-height: 25px;
	}
	
	.btn {
		border: none;
		display: block;
		margin: 0 auto;
		width: 160px;
		height: 48px;
		background: rgba(234, 234, 234, 1);
		border-radius: 4px;
	}
	.btn1{
		border: none;
		display: block;
		margin: 0 auto;
		width: 160px;
		height: 48px;
		background: rgba(24, 144, 255, 1);
		border-radius: 4px;
		color: #fff;
	}
	button:hover{
		background: blue;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Step2.vue